import script from "./ProvisionconfirmView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProvisionconfirmView.vue?vue&type=script&lang=ts&setup=true"

import "./ProvisionconfirmView.vue?vue&type=style&index=0&id=238be41c&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-238be41c"]])

export default __exports__